import { render, staticRenderFns } from "./UpdateEnrolmentModal.vue?vue&type=template&id=2b823946&"
import script from "./UpdateEnrolmentModal.vue?vue&type=script&lang=js&"
export * from "./UpdateEnrolmentModal.vue?vue&type=script&lang=js&"
import style0 from "./UpdateEnrolmentModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports